package org.zq.linkgame.ui.theme

import androidx.compose.ui.graphics.Color

// Primary Colors
val LightBlue = Color(0xFFE3F2FD)
val LightBlueStart = Color(0xFFBBDEFB)
val LightBlueEnd = Color(0xFFF3F9FF)
val LightYellow = Color(0xFFFFF9C4)
val LightGreen = Color(0xFFC8E6C9)
val LightGreenStart = Color(0xFFA5D6A7)
val LightGreenEnd = Color(0xFFE8F5E9)

// Button Colors
val OrangeRed = Color(0xFFFF5722)
val OrangeRedLight = Color(0xFFFF8A65)
val OrangeRedDark = Color(0xFFE64A19)
val LightOrangeRed = Color(0xFFFFAB91)

// Text Colors
val DeepBlue = Color(0xFF1565C0)
val DarkGray = Color(0xFF616161)
val LightGray = Color(0xFFBDBDBD)
val VeryLightGray = Color(0xFFEEEEEE)

// Icon Colors
val DeepGreen = Color(0xFF388E3C)
val Yellow = Color(0xFFFFC107)
val Green = Color(0xFF4CAF50)
val Red = Color(0xFFF44336)
val Blue = Color(0xFF2196F3)

// Social Media Colors
val WeChatGreen = Color(0xFF07C160)
val QQBlue = Color(0xFF12B7F5)
val WeiboOrange = Color(0xFFE6162D)

// Game UI Colors
val SelectionBlue = Color(0xFF1976D2)
val CellBorder = Color(0xFFE0E0E0)
val HintAreaBg = Color(0xFFE1F5FE)

// Background gradient colors for main screen (sky effect)
val SkyGradientTop = Color(0xFFBBDEFB)
val SkyGradientBottom = Color(0xFFF5FAFF)

// Background gradient colors for level selection (nature effect)
val NatureGradientTop = Color(0xFFA5D6A7)
val NatureGradientBottom = Color(0xFFE8F5E9)
